var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          ref: "popoverTarget",
          staticClass: "tooltip-target no-outline",
          attrs: { tabindex: "-1" },
        },
        [
          _vm._t("default", function () {
            return [
              _c(
                "a",
                {
                  ref: "promptLink",
                  staticClass: "prompt-link clickable",
                  class: { disabled: _vm.disabled },
                },
                [
                  _vm._t("default", function () {
                    return [
                      _vm.actionText
                        ? _c("span", { class: _vm.actionClassText }, [
                            _vm._v(_vm._s(_vm.actionText)),
                          ])
                        : _c("em", {
                            key: "actionIcon",
                            staticClass: "fa",
                            class: _vm.actionClassIcon,
                          }),
                    ]
                  }),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.componentReady
        ? _c(
            "b-popover",
            {
              ref: "popover",
              attrs: {
                container: _vm.container,
                target: _vm.$refs.popoverTarget,
                triggers: "click blur",
                placement: _vm.placement,
                boundary: "viewport",
                show: _vm.open,
                "custom-class": "inline-prompt",
                disabled: _vm.disabled,
              },
              on: {
                "update:show": function ($event) {
                  _vm.open = $event
                },
                show: _vm.handleShow,
                hide: _vm.handleHide,
              },
            },
            [
              _c(
                "div",
                { staticClass: "pre-confirmation-content" },
                [_vm._t("preConfirmationContent")],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "d-inline-flex align-items-center justify-content-center",
                    class: _vm.confirmationTextClass + " mr-2",
                  },
                  [
                    _c(
                      "span",
                      {
                        class:
                          "confirmation-text pr-2 " + _vm.confirmationTextColor,
                      },
                      [_vm._v(_vm._s(_vm.confirmationTextToUse))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c(
                          "simple-button",
                          {
                            ref: "acceptLink",
                            class: _vm.acceptTextClass,
                            attrs: {
                              type: _vm.acceptButtonType,
                              "class-name": "prompt-link accept-link clickable",
                              loading: _vm.loading,
                            },
                            on: { click: _vm.handleAcceptClick },
                          },
                          [
                            _vm.acceptType === "text"
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(_vm.acceptContent) + " "),
                                ])
                              : _vm.acceptType === "icon"
                              ? _c("em", {
                                  staticClass: "fa",
                                  class: _vm.acceptClass,
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "d-none" }, [
                              _vm._v(
                                _vm._s(_vm.$t("filogix.expertSync.accept"))
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        ref: "dismissLink",
                        staticClass: "prompt-link clickable ml-2",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDismissClick.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm.dismissType === "text"
                          ? _c("span", [
                              _vm._v(" " + _vm._s(_vm.dismissContent) + " "),
                            ])
                          : _vm.dismissType === "icon"
                          ? _c("em", {
                              staticClass: "text-gray fa",
                              class: _vm.dismissClass,
                            })
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }